import React from "react";
import { useNavigate } from "react-router-dom";
import "./TrackOrderComponent.css"; // Import external CSS
import Icons from "../../../../Config/Images";

const TrackOrderComponent = ({ orderData, closeThePopUp }) => {
  const handleModalClose = () => {
    // navigate("/my-account/my-orders");
    closeThePopUp();
  };
  // Order stages
  const stages = [
    "Pickup requested",
    "PICKED UP",
    "IN TRANSIT",
    "OUT FOR DELIVERY",
    "DELIVERED",
  ];

  // Find index of current stage
  // const currentStageIndex = stages.indexOf(orderData?.status || "");
  const currentStageIndex = stages.indexOf(
    orderData?.tracking?.[orderData?.tracking?.length - 1]?.description
    // orderData.tracking[orderData.tracking.length-1].description || ""
  );
  return (
    <div className="trackorder-overlay">
      <div className="trackorder-modal">
        {/* <button className="trackorder-close" onClick={handleModalClose}>
        &times;
      </button> */}
        <img
          src={Icons.cross_icon}
          className="trackorder-close"
          alt=""
          onClick={handleModalClose}
        />
        <h2 className="trackorder-title">Track Order</h2>

        <div className="trackorder-progressbar-wrapper">
          {/* <div className="trackorder-progressbar-line"> */}
          {/* </div> */}
          <div className="trackorder-progressbar-line" />

          <div className="trackorder-progressbar">
            {stages.map((stage, index) => (
              <div
                key={index}
                className={`progress-step ${
                  index <= currentStageIndex ? "active" : ""
                }`}
              >
                <div className="step-circle">{index + 1}</div>
                <span className="step-label">{stage}</span>
              </div>
            ))}
          </div>
        </div>

        {/* <div className="trackorder-details">
        <p><strong>Order ID:</strong> {orderData?.id}</p>
        <p><strong>Status:</strong> {orderData?.status}</p>
        <p><strong>Expected Delivery:</strong> {orderData?.expectedDelivery}</p>
      </div> */}

        {/* <div className="trackorder-actions">
        <button className="trackorder-button" onClick={handleModalClose}>
          Close
        </button>
      </div> */}
      </div>
    </div>
  );
};

export default TrackOrderComponent;
